var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.034 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    d: "M17.726 3.33L14.666.27a.979.979 0 0 0-1.35 0L1.436 12.15v.09a.088.088 0 0 1-.09.09.088.088 0 0 1-.09.09v.27L0 16.74a1.016 1.016 0 0 0 .27.99 1.022 1.022 0 0 0 .72.27h.27l4.14-1.17h.27a.088.088 0 0 0 .09-.09.088.088 0 0 0 .09-.09L17.726 4.77A1.022 1.022 0 0 0 18 4.05a1.022 1.022 0 0 0-.274-.72zm-14.76 9.99l8.46-8.46 1.71 1.71-8.46 8.46-2.25.63zm11.52-8.19l-1.71-1.71 1.08-1.08 1.71 1.71z",
    className: "cls-1",
    "data-name": "Path 150",
    transform: "translate(.038)"
  })));
}
export default __webpack_public_path__ + "static/media/ic_pencil.ae9c2234.svg";
export { SvgIcPencil as ReactComponent };